import { useFeatureFlag } from '@artic/ui/feature-flag';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { billOfOperationsMatrixQueryOptions } from '../../../features/bill-of-operations/queries';
import { RelevanceRulesList } from '../../../features/bill-of-operations/relevance-rules-list';
import { RuleEditorDialog } from '../../../features/bill-of-operations/rule-editor-dialog';
import { usePartnerId } from '../../../features/inbox/use-partner-name';

export const Route = createFileRoute('/bill_of_operations/rules/')({
  staticData: {
    breadcrumb: 'Rules',
    layout: 'full-height',
  },
  component: RelevanceRulesPage,
});

function RelevanceRulesPage() {
  const plannerEnabled = useFeatureFlag('planner');

  if (!plannerEnabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature Not Available</h2>
        <p className="text-muted-foreground text-sm">
          The Relevance Rules editor is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <RelevanceRulesContent />;
}

function RelevanceRulesContent() {
  const partnerId = usePartnerId();

  const [ruleEditorOpen, setRuleEditorOpen] = useState(false);

  const { data: matrix } = useQuery(billOfOperationsMatrixQueryOptions(partnerId));

  return (
    <>
      <RelevanceRulesList
        partnerId={partnerId}
        onOpenRuleEditor={() => {
          setRuleEditorOpen(true);
        }}
      />
      {ruleEditorOpen && (
        <RuleEditorDialog
          open={ruleEditorOpen}
          onOpenChange={setRuleEditorOpen}
          partnerId={partnerId}
          operations={matrix?.operations ?? []}
        />
      )}
    </>
  );
}
